var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D04A02;}\r\n\t.st1{fill:#E0301E;}\r\n\t.st2{fill:#DB536A;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#464646;}\r\n\t.st5{fill:#7D7D7D;}\r\n\t.st6{fill:#2D2D2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Down-Chevron_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_9_",
    d: "M84.2,30.6L52,62.7L19.8,30.6c-0.9-0.9-2.3-0.9-3.2,0c-0.9,0.9-0.9,2.3,0,3.2L52,69.1l35.3-35.3 c0.9-0.9,0.9-2.3,0-3.2C86.5,29.7,85,29.7,84.2,30.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.753343acdf669c8ea1072fc3d00ee4d3.svg";
export { ForwardRef as ReactComponent };